export const Config = {
    baseFolder: '',
    apiRoot: 'https://admin.udruzenjeosiguravaca.net/api/v1/',
    protectionOff: false
};
